<template>
  <TemplateView>
    <div class="container">
      <div
        class="d-flex flex-wrap mb-8"
        v-if="$userCheckAccess({ abilities: 'view_project_subscribers' })"
      >
        <template v-for="(page, p) in list">
          <BaseButton
            v-if="page.if"
            :key="'settingCompany' + p"
            :text="page.text"
            style-type="chip"
            :disabled="$route.name === page.toName || $route.name === page.toName + 'Edit'"
            @click="$router.push({ name: page.toName })"
          />
        </template>
      </div>
      <TemplatePageGrid
        :items="showList"
        :page-data="pageData"
        :loading="loadingAnimation"
        :change-style="!pageSubscribers"
        sort-az="last_name"
        :key="$route.name"
      >
        <template v-slot:buttons>
          <UserInviteModal
            v-if="$userCheckAccess({ abilities: 'add_users' })"
            key="UserInviteModal"
            :onDownloadPageData="onDownloadPageData"
            :subscriber="pageSubscribers"
          />
          <template
            v-if="!pageSubscribers ? commonUserGrid.length : commonUserSubscribersGrid.length"
          >
            <UserAssingRolesModal
              v-if="$userCheckAccess({ abilities: 'assign_user_roles' })"
              key="UserAssingRolesModal"
              :subscriber="!!pageSubscribers"
              :onDownloadPageData="onDownloadPageData"
            />
            <SettingsSubscribersModal
              v-if="pageSubscribers && $userCheckAccess({ abilities: 'edit_project_subscribers' })"
              :onDownloadPageData="onDownloadPageData"
            />
          </template>
        </template>
        <template v-slot:filters>
        </template>
        <UsersTable
          v-if="$route.query.style_list === 'table' || pageSubscribers"
          :userGrid="showList"
          :onDownloadPageData="onDownloadPageData"
          :subscriber="pageSubscribers"
        />
        <div class="users_grid" v-else>
          <UsersListItem
            v-for="(user, key) in showList"
            :key="key"
            :user="user"
            style_list="grid"
            :onDownloadPageData="onDownloadPageData"
            :subscriber="pageSubscribers"
          />
        </div>
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import UsersTable from 'components/setting/users/UsersTable'
import UserInviteModal from 'components/setting/users/UserInviteModal'
import UsersListItem from 'components/setting/users/UsersListItem'
import UserAssingRolesModal from 'components/setting/users/UserAssingRolesModal'
import SettingsSubscribersModal from 'components/setting/users/subscribers/SettingsSubscribersModal'

export default {
  name: 'SettingsUsers',
  components: {
    UsersListItem,
    UsersTable,
    UserInviteModal,
    UserAssingRolesModal,
    SettingsSubscribersModal,
  },
  data() {
    return {
      statusFilter: [],
      roleFilter: [],
      employeeFilter: [],
      offerFilter: [],
    }
  },
  created() {
    // this.listOfRolesAll()
    this.onDownloadPageData()
    if (this.$route.query) {
      if (this.$route.query.status && this.$route.query.status) {
        this.statusFilter = this.$route.query.status
      }
    }
  },
  computed: {
    ...mapGetters(['apiDomain']),
    ...mapGetters('commonUser', ['commonUserGrid', 'commonUserSubscribersGrid', 'pageData']),
    // ...mapGetters('commonRole', ['rolesAllData']),
    ...mapGetters(['loadingAnimation']),
    pageSubscribers() {
      return this.$route.name === 'SettingUsers-subscribers'
    },
    showList() {
      return !this.pageSubscribers ? this.commonUserGrid : this.commonUserSubscribersGrid
    },
    statusList() {
      return [
        {
          text: this.localStorage.translations.pages['setting-users'].status.authorized,
          value: 'authorized',
        },
        {
          text: this.localStorage.translations.pages['setting-users'].status.invited,
          value: 'invited,not_completed',
        },
        {
          text: this.localStorage.translations.pages['setting-users'].status.restore,
          value: 'restore',
        },
        {
          text: this.localStorage.translations.pages['setting-users'].status.blocked,
          value: 'blocked',
        },
      ]
    },
    list() {
      return [
        {
          toName: 'SettingUsers',
          text: this.localStorage.translations.pages.setting.pages['polzovateli'],
          if: true,
        },
        {
          toName: 'SettingUsers-subscribers',
          text: this.localStorage.translations.pages['sales_project'][
            'planned_resources-subscribers'
          ].title,
          if: this.$userCheckAccess({
            abilities: 'view_project_subscribers',
          }),
        },
      ]
    },
  },
  watch: {
    '$route.query'(newData, oldData) {
      if (newData.style_list === oldData.style_list) {
        this.onDownloadPageData()
      }
    },
    '$route.name'() {
      this.onDownloadPageData()
    },
  },
  methods: {
    ...mapActions('commonUser', ['onCommonUserGrid', 'onCommonUserSubscribersGrid']),
    ...mapMutations(['setLoadingAnimation']),
    // ...mapActions('commonRole', ['listOfRolesAll']),
    async onDownloadPageData() {
      this.setLoadingAnimation(true)
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      const keys = ['status', 'role', 'last_name']
      if (this.$filterQueryParams(keys)) {
        data.filters = this.$filterQueryParams(keys)
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      await this[!this.pageSubscribers ? 'onCommonUserGrid' : 'onCommonUserSubscribersGrid'](data)
      this.setLoadingAnimation(false)
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-wrap {
  gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    gap: 12px;
  }
}
.users_grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  width: 100%;

  @media #{map-get($display-breakpoints, 'lg-only')} {
    grid-template-columns: repeat(4, 1fr);
  }
  @media #{map-get($display-breakpoints, 'md-only')} {
    grid-template-columns: repeat(3, 1fr);
  }
  @media #{map-get($display-breakpoints, 'sm-only')} {
    grid-template-columns: repeat(2, 1fr);
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    grid-template-columns: 1fr;
  }
}
</style>